'use client';
import React, { useEffect, useState } from 'react';
import { Button, Div, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import { ConsultItemsProps } from '../../consults.props';
import Link from 'next/link';
import routes from '@routes';
import getParseRoute from '@utils/helpers/parse-route';
import AppointmentIcon from '@icons-components/appointment-icon';
import ConsultIcon from '@icons-components/consult-icon';
import VideoIcon from '@icons-components/video-icon';
import LocationOutlineIcon from '@icons-components/location-outline-icon';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const ConsultItemDesktop = (props: ConsultItemsProps) => {
  const [hasConsult, setHasConsult] = useState(false);
  const [hasAppointment, setHasAppointment] = useState(false);
  const { photo, name, title, slug, userServiceFee, provinceTitle } = props;
  const { lang } = useParams<{lang: LocaleTypes}>();
  useEffect(() => {
    userServiceFee && userServiceFee.length > 0 && userServiceFee.map((item: any) => {
      if (item?.type_id === 1) {
        setHasAppointment(true);
      }
      if (item?.type_id === 2) {
        setHasConsult(true);
      }
    });
  }, [userServiceFee]);

  return (
    <Div itemScope itemType="http://schema.org/Physician" className={'relative bg-darkBlue-50 items-center rounded-xl z-[5] gap-y-2 mt-12 flex-col'}>
      <Div className={'-translate-y-1/2 w-16 h-16 relative object-contain border-2 border-control-200 rounded-full'}>
        <Link passHref={true} href={getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug }, locale: lang })}>
          {photo ? <Image itemProp="image" className={'rounded-full'} sizes={'10vw'} src={photo} alt={name}/> : null}
        </Link>
      </Div>
      <Div className={'w-full self-center justify-evenly'}>
        <Button
          ariaLabel={'Appointment'}
          shape={'square'}
          rounded={'full'}
          color={'primary'}
          className={'!px-0 relative'}
          disabled={!hasAppointment || true}
          href={hasAppointment ? getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug, id: '1' }, locale: lang }) : '#'}
          startAdornment={<AppointmentIcon/>}
        />
        <Button
          ariaLabel={'Consult'}
          shape={'square'}
          rounded={'full'}
          color={'primary'}
          className={'!px-0'}
          disabled={!hasConsult}
          href={hasConsult ? getParseRoute({ pathname: routes['route.consults.dialogue-box'], query: { slug: slug }, locale: lang }) : '#'}
          startAdornment={<ConsultIcon/>}
        />
        <Button
          ariaLabel={'Video Consult'}
          shape={'square'}
          rounded={'full'}
          color={'primary'}
          className={'!px-0'}
          disabled={true}
          href={''}
          startAdornment={<VideoIcon/>}
        />
      </Div>
      <Div className={'items-center flex-col'}>
        <Link
          passHref={true}
          href={getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug }, locale: lang })}
          className={'h-32 overflow-hidden text-ellipsis'}>
          <Text itemProp="name" typography={'base'} type={'medium'} color={'grey.900'} className={'w-full mb-2'}>
            {name}
          </Text>
          <Text itemProp="description" typography={'sm'} color={'grey.500'} className={'w-full mb-2'}>
            {title}
          </Text>
        </Link>
      </Div>
      <Div className={'items-center flex-row text-grey-500'}>
        <LocationOutlineIcon/>
        <Text typography={'sm'} color={'grey.600'} style={{ marginRight: '6px' }}>{provinceTitle}</Text>
      </Div>
      <Div className={'flex-col mb-2 gap-y-2'}>
        <Button
          fontType={'bold'}
          href={hasAppointment ? getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug, id: '1' }, locale: lang }) : '#'}
          disabled={!hasAppointment || true}
          className={'w-44'}>
          {props.translate.submit_appointment}
        </Button>
        <Button
          fontType={'bold'}
          href={hasConsult ? getParseRoute({ pathname: routes['route.consults.dialogue-box'], query: { slug: slug }, locale: lang }) : '#'}
          disabled={!hasConsult}
          className={'w-44'}>
          {props.translate.submit_consult}
        </Button>
      </Div>
    </Div>
  );
};

export default ConsultItemDesktop;
